var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAttractionWhite1212 = function SvgAttractionWhite1212(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9.343 3.84C9.343 2.053 7.844.6 6 .6S2.657 2.053 2.657 3.84C2.657 6.27 6 9.78 6 9.78s3.343-3.51 3.343-5.94m-4.457 0c0-.594.501-1.08 1.114-1.08s1.114.486 1.114 1.08S6.618 4.92 6 4.92c-.613 0-1.114-.486-1.114-1.08M2.1 10.32v1.08h7.8v-1.08z"
  })));
};
export default SvgAttractionWhite1212;